angular.module('unergie.main')
.directive('versionBand', ($rootScope, $interval, $uibModal) =>
    ({
        restrict: 'E',
        templateUrl: '/states/home/component/versionBand/versionBand.html',
        link($scope, $uibModalInstance, ErrorCatcher) {
            $scope.close = $uibModalInstance.dismiss
            $scope.ok = $uibModalInstance.close

            const versionPopupText = 'Une nouvelle version du BackOffice est disponible : votre navigateur sera rafraîchi automatiquement dans 10 minutes. Souhaitez-vous le faire tout de suite ?'
            const refresh = () => {
                window.location.reload()
            }
            const openModal = (text, showButtons) => {
                const modalInstance = $uibModal.open({
                    animation: true,
                    size: 'md',
                    backdrop: 'static',
                    controller: 'newVersionModalCtrl',
                    templateUrl: '/states/home/component/newVersionModal/newVersionModal.html',
                    resolve: {
                        text() {
                            return text
                        },
                        showButtons() {
                            return showButtons
                        },
                    },
                })
                modalInstance.result.then((ok) => {
                    if (ok) {
                        refresh()
                    }
                })
            }
            let now = new Date().getTime()
            const countdown = new Date(now + (20 * 60000))
            const x = setInterval(() => {
                const delta = countdown - now
                const minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60))
                const seconds = Math.floor((delta % (1000 * 60)) / 1000)

                // Output the result in an element with id="demo"
                document.getElementById('countdown-timer').innerHTML = `${minutes}m ${seconds}s`
                now = new Date().getTime()
                // If the count down is over, write some text
                if (delta > 599000 && delta < 600000) {
                    openModal(versionPopupText, true)
                }
                if (delta < 0) {
                    refresh()
                    clearInterval(x)
                    document.getElementById('countdown-timer').innerHTML = 'EXPIRED'
                }
            }, 1000)
        },
    })
)
